import useReactHookForm from "hooks/useReactHookForm";

import { useAppDispatch } from "hooks/redux";
import { Button, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import {
  hasAtLeastOneValue,
  chapterInitialValues,
  chapterMandatoryFields,
  chapterProperties,
  chapterValidationSchema,
} from "./helper";
import { isEmpty } from "utils/helpers";
import { useEffect } from "react";

export const ChapterFilter = ({
  setSearchPayload,
  setPage,
  clearValuesTrigger,
}) => {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    chapterInitialValues,
    chapterValidationSchema,
    ""
  );
  const dispatch = useAppDispatch();

  const clearFilter = () => {
    setValue("global_name", "");
    setValue("status", "");
    setSearchPayload({});
    setPage(1);
  };
  const handleSearch = () => {
    const payload = {
      global_name: watch()?.global_name,
    };
    if(!isEmpty(watch()?.status)){
      payload["status"]= watch()?.status
    }
    setSearchPayload(payload);
    setPage(1);
  };
  useEffect(() => {
    clearFilter();
  }, [clearValuesTrigger]);

  return (
    <div>
      <Paper elevation={2} sx={{ px: 2, pb: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={chapterProperties}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
          <ContentRight sx={{ mt: -7 }}>
            <Button
              variant="contained"
              sx={{
                width: "70px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={clearFilter}
              disabled={!hasAtLeastOneValue(watch(),["status","global_name"])}
            >
              clear
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "80px",
                height: "40px",
                marginTop: "15px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleSearch}
              disabled={!hasAtLeastOneValue(watch(),["status","global_name"])}
            >
              search
            </Button>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
};
